import React, { useState, useEffect, useRef } from "react";

// material ui
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

import useStyles from "./styles";

import validation from "../validation";
import moment from "moment";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";

import InfoButton from "../../../../../components/InfoButton";

function SubFormRadio_16({
  id,
  setValue,
  saveValue,
  saveChangeValue,
  value,
  form,
  keluarga,
  no_kk,
  isSubmitting,
  pk,
  subformIndex,
  handleBackSub,
}) {
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});

  const [berlaku, setBerlaku] = useState(false);

  const [jawabanA, setJawabanA] = useState(value.jawabanA || "");
  const [jawabanB, setJawabanB] = useState(value.jawabanB || "");
  const [jawabanC, setJawabanC] = useState(value.jawabanC || "");
  const [jawabanD, setJawabanD] = useState(value.jawabanD || "");

  useEffect(() => {
    const anggotaKeluarga = Object.values(keluarga);
    const kepalaKeluarga = anggotaKeluarga.some(
      (member) => member.sts_hubungan === "1" && member.jenis_kelamin === "1"
      // &&(member.sts_kawin === "2" || member.sts_kawin === "3")
    );

    // console.log("keluarga>>>", anggotaKeluarga);

    const cekChild = () => {
      const yearDiff = (tanggal) => {
        const dateA = moment();
        const dateB = moment(tanggal);
        const year = dateA.diff(dateB, "years", true);
        return parseInt(year);
      };
      let res = false;
      anggotaKeluarga.forEach((el) => {
        const dateParts = el.tgl_lahir.split("-");
        const tglLahir = new Date(
          +dateParts[2],
          +dateParts[1] - 1,
          +dateParts[0]
        );
        const age = yearDiff(tglLahir);
        // console.log("umur anak>>>", age);
        // console.log("status hubungan>>>", el.sts_hubungan);
        // console.log("status kawin>>>", el.sts_kawin);

        if (+el.sts_hubungan === 3 && +el.sts_kawin === 1 && age <= 24) {
          res = true;
        }
      });
      return res;
    };

    // const anak = anggotaKeluarga.some(
    //   (member) =>
    //     member.sts_hubungan === "3" &&
    //     member.umur < 24 &&
    //     member.sts_kawin === "1"
    // );
    // const cerai =
    //   anggotaKeluarga[0] &&
    //   (anggotaKeluarga[0].sts_kawin === "4" ||
    //     anggotaKeluarga[0].sts_kawin === "5" ||
    //     anggotaKeluarga[0].sts_kawin === "6");

    // console.log("Checking berlaku condition:", { kepalaKeluarga, anak });
    // if (cerai && anak) {
    //   setBerlaku(true);
    // } else

    // console.log("kepala keluarga>>>", kepalaKeluarga);
    // console.log("anak>>>", cekChild());
    // console.log("anakkkkkk>>>", cekChild);

    if (kepalaKeluarga && cekChild()) {
      setBerlaku(true);
      // console.log("Setting berlaku = true");
    } else {
      setBerlaku(false);
      // console.log("Setting berlaku = false");
      if (!jawabanA) {
        setValue({ target: { name: "jawabanA", value: "3" } });
        setJawabanA("3");
      }
      if (!jawabanB) {
        setValue({ target: { name: "jawabanB", value: "3" } });
        setJawabanB("3");
      }
      if (!jawabanC) {
        setValue({ target: { name: "jawabanC", value: "3" } });
        setJawabanC("3");
      }
      if (!jawabanD) {
        setValue({ target: { name: "jawabanD", value: "3" } });
        setJawabanD("3");
      }
    }
  }, []);

  useEffect(() => {
    setError({});
  }, []);

  // useEffect(() => {
  //   // console.log("SubFormRadio_16 - value props:", value);
  //   // console.log("SubFormRadio_16 - current local states:", {
  //   //   jawabanA,
  //   //   jawabanB,
  //   //   jawabanC,
  //   //   jawabanD,
  //   // });
  //   if (value._rev && !jawabanA && !jawabanB && !jawabanC && !jawabanD) {
  //     setJawabanA(value.jawabanA || "");
  //     setJawabanB(value.jawabanB || "");
  //     setJawabanC(value.jawabanC || "");
  //     setJawabanD(value.jawabanD || "");
  //   }
  // }, [value._rev]);

  // console.log("subformradio");
  // console.log("Current berlaku status:", berlaku);
  // console.log("Current answers:", { jawabanA, jawabanB, jawabanC, jawabanD });

  // useEffect(() => {
  //   //console.log('validation called');
  //   if (form.dependencies.length <= 0) {
  //     setBerlaku(true);
  //   } else {
  //     const valuesKel = Object.values(keluarga);
  //     const cekberlaku = form.dependencies.some((dep) => {
  //       return validation[dep](valuesKel);
  //     });

  //     if (!cekberlaku) {
  //       setValue({ target: { name: "jawaban", value: "3" } });
  //     }
  //     setBerlaku(cekberlaku);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [id, form]);

  const {
    pertanyaan,
    pertanyaanA,
    pertanyaanB,
    pertanyaanC,
    pertanyaanD,
    definisi_operasional,
  } = form;

  const handleChange = (e) => {
    if (e.target.type === "number") {
      if (parseInt(e.target.value) < 0) return false;

      // if (e.target.name === "kondisi" && ![0, 1].includes(parseInt(e.target.value))) {
      //     return false;
      // }
    }

    setValue(e);

    setError({
      ...error,
      [e.target.name]: "",
    });

    switch (e.target.name) {
      case "jawabanA":
        setJawabanA(e.target.value);
        break;
      case "jawabanB":
        setJawabanB(e.target.value);
        break;
      case "jawabanC":
        setJawabanC(e.target.value);
        break;
      case "jawabanD":
        setJawabanD(e.target.value);
        break;

      default:
        break;
    }

    // setSomethingChange(true)
  };

  useEffect(() => {
    let normalizeValue = {
      Pertanyaan: pertanyaan,
      Jawab_Pilih: 0,
      Jawaban_H1: value.kondisi || 0,
      Jawaban_H2: 0,
      No_Pertanyaan: parseInt(form.no),
      Lainnya: value.jawaban_lainnya || "",
      answer: [
        {
          No_Jawaban: 1,
          pilihanpk: jawabanA,
        },
        {
          No_Jawaban: 2,
          pilihanpk: jawabanB,
        },
        {
          No_Jawaban: 3,
          pilihanpk: jawabanC,
        },
        {
          No_Jawaban: 4,
          pilihanpk: jawabanD,
        },
      ],
    };
    if (value._rev) {
      normalizeValue._rev = value._rev;
    }
    saveChangeValue(normalizeValue);
  }, [jawabanA, jawabanB, jawabanC, jawabanD]);

  const validate = () => {
    let newError = {};

    // console.log("Validating:", {
    //   jawabanA,
    //   jawabanB,
    //   jawabanC,
    //   jawabanD,
    //   berlaku,
    // });

    // If not applicable (berlaku = false), all answers should be "3" (Tidak Berlaku)
    if (!berlaku) {
      // When not applicable, we don't validate - all should be set to "3"
      return newError;
    }

    // Only validate when berlaku = true
    if (!jawabanA) {
      newError.jawabanA = "Wajib diisi";
    }

    if (!jawabanB) {
      newError.jawabanB = "Wajib diisi";
    }

    // if (!berlaku) {
    //   // if (value.jawabanB != 3) {
    //   newError.jawabanB = "Jawaban selain tidak berlaku";
    //   // }
    // }

    if (!jawabanC) {
      newError.jawabanC = "Wajib diisi";
    }

    if (!jawabanD) {
      newError.jawabanD = "Wajib diisi";
    }

    // console.log("Validation errors:", newError);
    return newError;
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    // console.log("handleSubmit called");
    // console.log("Current state:", {
    //   jawabanA,
    //   jawabanB,
    //   jawabanC,
    //   jawabanD,
    //   berlaku,
    // });

    const findErrors = validate();
    const errorValues = Object.values(findErrors);

    // console.log("Validation result:", findErrors);
    // console.log("Error values:", errorValues);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      // console.log("Validation failed, setting errors");
      setError(findErrors);
    } else {
      // console.log("Validation passed, saving data");
      let normalizeValue = {
        Pertanyaan: pertanyaan,
        Jawab_Pilih: 0,
        Jawaban_H1: value.kondisi || 0,
        Jawaban_H2: 0,
        No_Pertanyaan: parseInt(form.no),
        Lainnya: value.jawaban_lainnya || "",
        answer: [
          {
            No_Jawaban: 1,
            pilihanpk: jawabanA,
          },
          {
            No_Jawaban: 2,
            pilihanpk: jawabanB,
          },
          {
            No_Jawaban: 3,
            pilihanpk: jawabanC,
          },
          {
            No_Jawaban: 4,
            pilihanpk: jawabanD,
          },
        ],
      };
      if (value._rev) {
        normalizeValue._rev = value._rev;
      }
      // console.log("Saving normalizeValue:", normalizeValue);
      saveValue(normalizeValue);
    }
  };
  //console.log('here')
  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <Typography margin="normal" paragraph>
              <span className={classes.badge}>{form.no}</span>
              <span dangerouslySetInnerHTML={{ __html: pertanyaan }} />
            </Typography>
            <div style={{ position: "absolute", right: "0", top: "83px" }}>
              <InfoButton
                title={`Pertanyaan ${form.no}`}
                content={form.definisi_operasional}
              />
            </div>
          </div>
          <div className={classes.cardBody} style={{ paddingTop: "40px" }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography>
                  <span dangerouslySetInnerHTML={{ __html: pertanyaanA }} />
                </Typography>
                <FormControl
                  error={error.jawabanA ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={jawabanA || ""}
                    onChange={handleChange}
                    aria-label="jawabanA"
                    name="jawabanA"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="3"
                      label="Tidak Berlaku"
                      labelPlacement="end"
                      disabled={berlaku}
                    />
                  </RadioGroup>
                  <FormHelperText>{error.jawabanA}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  <span dangerouslySetInnerHTML={{ __html: pertanyaanB }} />
                </Typography>
                <FormControl
                  error={error.jawabanB ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={jawabanB || ""}
                    onChange={handleChange}
                    aria-label="jawabanB"
                    name="jawabanB"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="3"
                      label="Tidak Berlaku"
                      labelPlacement="end"
                      disabled={berlaku}
                    />
                  </RadioGroup>
                  <FormHelperText>{error.jawabanB}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  <span dangerouslySetInnerHTML={{ __html: pertanyaanC }} />
                </Typography>
                <FormControl
                  error={error.jawabanC ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={jawabanC || ""}
                    onChange={handleChange}
                    aria-label="jawabanC"
                    name="jawabanC"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="3"
                      label="Tidak Berlaku"
                      labelPlacement="end"
                      disabled={berlaku}
                    />
                  </RadioGroup>
                  <FormHelperText>{error.jawabanC}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  <span dangerouslySetInnerHTML={{ __html: pertanyaanD }} />
                </Typography>
                <FormControl
                  error={error.jawabanD ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={jawabanD || ""}
                    onChange={handleChange}
                    aria-label="jawabanD"
                    name="jawabanD"
                    row
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="Ya"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="Tidak"
                      labelPlacement="end"
                      disabled={!berlaku}
                    />{" "}
                    <FormControlLabel
                      control={<Radio />}
                      value="3"
                      label="Tidak Berlaku"
                      labelPlacement="end"
                      disabled={berlaku}
                    />
                  </RadioGroup>
                  <FormHelperText>{error.jawabanD}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          {subformIndex >= 31 ||
          (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")
            ? "Selanjutnya"
            : "Selanjutnya"}{" "}
          <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubFormRadio_16;
